<template>
<div>
  <div v-show="!showUpdate" class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Settings"
              bc1="App"
              bc2="Settings"
              bc3="List"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click="$router.push({ name: 'settings-add' })"
                  >
                    <AddButtonText name="Setting" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <CommonTableStore
              :url="url"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :deleteActions="deleteActions"
              :mutedData="mutedData"
              :storageKey="storageKey"
              :externalTotalRecord="externalTotalRecord"
              :show-per-page="true"
          />
        </div>
      </div>
    </div>
  </div>
  <UpdateSettings @back="showUpdate = false" v-if="showUpdate" />
</div>
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import UpdateSettings from "@/pages/dashboard/settings/UpdateSettings.vue";
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";

export default {
  components: {AddButtonText, UpdateSettings, CommandIcon },
  created() {},
  async mounted() {
    localStorage.setItem("url", "v1/get-settings");
    this.checkDataInStore('v1/get-settings')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      url: "v1/get-settings",
      storageKey: "setting",
      showUpdate:false,
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name"
        },
        // {
        //   title: "Type",
        //   valueKey: "type",
        //   html: true,
        //   alter: function(value) {
        //     var html = "";
        //     if (value) {
        //       html = `<span class="text-primary">${value}</span>`;
        //       return html;
        //     } else {
        //       html = "-";
        //       return html;
        //     }
        //   }
        // },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
            }

            if (row.is_default == 1) {
              html += '<span class="badge badge-secondary ml-1">Default</span>';
            }

            return html;
          }
        }
      ],
      actions: [
        {
          title: "Update",
          cta: (row, index) => {
            let data = {
              ...row,
              index: index,
              row: row,
              key: "settingsUpdate",
              storageKey: this.storageKey,
              idx: index,
            }
            this.$store.dispatch("set", data);
            this.showUpdate = true
            // this.$router.push({ name: "settings-update" });
          }
        }
      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            this.deleteRecord(row, index);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: ""
    };
  },
  methods: {
    deleteRecord(row) {
      this.makeRequest("post", "v1/delete-settings", {
        status: row.status == true ? 1 : 0,
        id: row.id
      });
    }
  }
};
</script>
